// M146 Fase 3 — Universele status-badge.
// Iconen zorgen dat status óók zonder kleur onderscheidbaar is (a11y).
// Kleuren komen exact overeen met de warm-wit + petrol/mint stijlgids.
import { Check, Circle, AlertCircle, XCircle, Clock } from "lucide-react";

const VARIANTS = {
  gekoppeld: {
    icon: Check,
    bg: "rgba(33, 122, 82, 0.15)",   // pos-green @ 15%
    fg: "#217A52",
    label: "Gekoppeld",
  },
  "actie-nodig": {
    icon: AlertCircle,
    bg: "rgba(138, 91, 19, 0.12)",   // warn-amber @ 12%
    fg: "#8A5B13",
    label: "Actie nodig",
  },
  "niet-gekoppeld": {
    icon: Circle,
    bg: "#EEF1EE",                   // rustig grijs
    fg: "#4A5C60",                   // M147: donkerder voor WCAG AA 4.5:1
    label: "Nog niet gekoppeld",
  },
  voorbereid: {
    icon: Clock,
    bg: "#EEF1EE",
    fg: "#4A5C60",                   // M147: donkerder voor WCAG AA
    label: "Voorbereid — binnenkort",
  },
  fout: {
    icon: XCircle,
    bg: "rgba(182, 66, 66, 0.10)",   // rustig-rood @ 10%
    fg: "#B64242",
    label: "Fout",
  },
  bezig: {
    icon: Clock,
    bg: "rgba(8, 127, 140, 0.10)",   // petrol @ 10%
    fg: "#087F8C",
    label: "Bezig",
  },
};

export function StatusBadge({ variant = "niet-gekoppeld", label, testid, className = "" }) {
  const v = VARIANTS[variant] || VARIANTS["niet-gekoppeld"];
  const Icon = v.icon;
  const text = label || v.label;
  return (
    <span
      data-testid={testid || `status-badge-${variant}`}
      role="status"
      aria-label={`Status: ${text}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${className}`}
      style={{ background: v.bg, color: v.fg }}
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2.5} aria-hidden="true" />
      <span>{text}</span>
    </span>
  );
}

export default StatusBadge;
